import React, { useState, useCallback, useEffect } from 'react';
import { Row, Col, Table, Modal, ModalBody, ModalFooter } from 'reactstrap';
import classNames from 'classnames';
import styles from './PlanOptions.module.css';
import ModalHeader from 'react-bootstrap/ModalHeader';
import { ReactComponent as CheckIcon } from '../../../assets/images/checkmark.svg';
import { ReactComponent as NoIcon } from '../../../assets/images/close.svg';
import { useHistory } from 'react-router';
import NJRTermsDocument from '../../../assets/Documents/NJR/njr-serviceplan-terms.pdf';

const PlanOptionModal = ({ isOpen, toggle, centered, isHome }) => {
    const history = useHistory();
    const [riskProfile, setRiskProfile] = useState(null);
    const [NJRConfigurations, setNJRConfigurations] = useState([]);

    const getRiskProfileFromAPI = useCallback(() => {
        let clientId = 'NJR';
        fetch(`api/pricing/riskProfile/getByMasterProgramId/20/16/${clientId}`)
            .then((res) => res.json())
            .then(
                (data) => {
                    setRiskProfile(data);
                },
                [riskProfile]
            );
    });

    const getRiskProfileListByMasterProgramId = useCallback((masterProgramId) => {
        fetch(`api/pricing/riskProfile/getRiskProfilesFromConfig/${masterProgramId}`)
            .then((res) => res.json())
            .then(
                (data) => {
                    setNJRConfigurations(data);
                },
                [NJRConfigurations]
            );
    });

    let kitchenMonthly = [{ totalBundlePrice: null }];
    let laundryMonthly = [{ totalBundlePrice: null }];
    let kitchenAndLaundryMonthly = [{ totalBundlePrice: null }];
    if (riskProfile != null) {
        kitchenMonthly = riskProfile.filter((rp) => rp.riskProfileId == NJRConfigurations.kitchenMonthly)[0];
        laundryMonthly = riskProfile.filter((rp) => rp.riskProfileId == NJRConfigurations.laundryMonthly)[0];
        kitchenAndLaundryMonthly = riskProfile.filter(
            (rp) => rp.riskProfileId == NJRConfigurations.kitchenAndLaundryMonthly
        )[0];
    }

    const handleSave = (e) => {
        e.preventDefault();
        history.push('/shopplan');
    };
    useEffect(() => {
        getRiskProfileFromAPI();
        getRiskProfileListByMasterProgramId(20);
    }, []);

    const planOptions = [
        {
            name: 'Kitchen Appliances',
            kitchenPlan: '',
            laundryPlan: '',
            totalBundlePlan: '',
            heading: true
        },
        {
            name: 'Cooking Product (range, oven or cooktop)',
            kitchenPlan: true,
            laundryPlan: false,
            totalBundlePlan: true,
            heading: false
        },
        {
            name: 'Dishwasher',
            kitchenPlan: true,
            laundryPlan: false,
            totalBundlePlan: true,
            heading: false
        },
        {
            name: 'Exhaust Fan',
            kitchenPlan: true,
            laundryPlan: false,
            totalBundlePlan: true,
            heading: false
        },
        {
            name: 'Garbage Disposal',
            kitchenPlan: true,
            laundryPlan: false,
            totalBundlePlan: true,
            heading: false
        },
        {
            name: 'Interior Electrical System',
            kitchenPlan: true,
            laundryPlan: false,
            totalBundlePlan: true,
            heading: false
        },
        {
            name: 'Microwave',
            kitchenPlan: true,
            laundryPlan: false,
            totalBundlePlan: true,
            heading: false
        },
        {
            name: 'Refrigerator (excluding ice maker)',
            kitchenPlan: true,
            laundryPlan: false,
            totalBundlePlan: true,
            heading: false
        },
        {
            name: 'Laundry Appliances',
            kitchenPlan: '',
            laundryPlan: '',
            totalBundlePlan: '',
            heading: true
        },
        {
            name: 'Clothes Washer',
            kitchenPlan: false,
            laundryPlan: true,
            totalBundlePlan: true,
            heading: false
        },
        {
            name: 'Clothes Dryer',
            kitchenPlan: false,
            laundryPlan: true,
            totalBundlePlan: true,
            heading: false
        },
        {
            name: 'Add-ons',
            kitchenPlan: '',
            laundryPlan: '',
            totalBundlePlan: '',
            heading: true
        },
        {
            name: 'Built-in Microwave',
            kitchenPlan: 'Add-on',
            laundryPlan: false,
            totalBundlePlan: 'Add-on',
            heading: false
        },
        {
            name: 'Cooking Product (range, oven or cooktop)',
            kitchenPlan: 'Add-on',
            laundryPlan: false,
            totalBundlePlan: 'Add-on',
            heading: false
        },
        {
            name: 'Refrigerator',
            kitchenPlan: 'Add-on',
            laundryPlan: false,
            totalBundlePlan: 'Add-on',
            heading: false
        },
        {
            name: 'Standalone Freezer',
            kitchenPlan: 'Add-on',
            laundryPlan: false,
            totalBundlePlan: 'Add-on',
            heading: false
        }
    ];

    const columns = [
        {
            name: 'Total Appliance Bundle',
            price: kitchenAndLaundryMonthly.totalBundlePrice
        },
        {
            name: 'Kitchen Appliances',
            price: kitchenMonthly.totalBundlePrice
        },
        {
            name: 'Laundry Appliances',
            price: laundryMonthly.totalBundlePrice
        }
    ];

    const TableCell = (data) => {
        if (data === 'Add-on') {
            return 'Add-on';
        }
        if (data === true) {
            return <CheckIcon className={classNames(styles.iconImage, styles.iconImageCheck)} />;
        }
        if (data === false) {
            return <NoIcon className={classNames(styles.iconImage, styles.iconImageNo)} />;
        }
    };

    const TableHeader = () => {
        return (
            <tr>
                <th className={classNames(styles.itemHead, styles.fixedCol)}>
                    <div className={styles.cell1}></div>
                </th>
                {columns.map((column) => {
                    return (
                        <th className={classNames(styles.itemHead)}>
                            <div>{column.name}</div>
                            <div>${column.price?.toFixed(2)}/month</div>
                        </th>
                    );
                })}
            </tr>
        );
    };
    const TableBody = () => {
        return (
            <>
                {planOptions.map((option, ind) => {
                    if (option.heading) {
                        return (
                            <tr
                                key={ind + '10000'}
                                className={styles.itemHeader}
                            >
                                <th
                                    scope='row'
                                    className={styles.fixedCol}
                                >
                                    <div>{option.name}</div>
                                </th>
                                <td></td>
                                <td></td>
                                <td></td>
                            </tr>
                        );
                    }
                    return (
                        <tr key={ind + '10000'}>
                            <th
                                className={classNames(styles.itemHead, styles.fixedCol)}
                                scope='row'
                            >
                                <div>{option.name}</div>
                            </th>
                            <td>{TableCell(option.totalBundlePlan)}</td>
                            <td>{TableCell(option.kitchenPlan)}</td>
                            <td>{TableCell(option.laundryPlan)}</td>
                        </tr>
                    );
                })}
            </>
        );
    };
    return (
        <Modal
            isOpen={isOpen}
            toggle={toggle}
            centered={centered}
            isHome={isHome}
            labelledBy='heading'
            autoFocus={true}
            className={classNames('modal-lg', styles.customModal)}
        >
            <ModalHeader className={styles.saveCardHeader}>
                <h1 className='modalTitle h5 mb-0'>Compare Plan Options*</h1>
            </ModalHeader>
            <ModalBody className={styles.planOptionModalBody}>
                <Row>
                    <Col
                        lg='12'
                        md='12'
                        sm='12'
                    >
                        <Table
                            bordered
                            responsive
                            className={styles.planTable}
                        >
                            <thead>{TableHeader()}</thead>
                            <tbody>{TableBody()}</tbody>
                        </Table>
                        <div className={styles.terms}>
                            <sup>*</sup>Limitations and exclusions apply. See the complete{' '}
                            <a
                                className={styles.link}
                                onClick={() => window.open(NJRTermsDocument)}
                            >
                                terms and conditions
                            </a>
                            .
                        </div>
                    </Col>
                </Row>
            </ModalBody>
            <ModalFooter>
                <div className={styles.modalFooterBtnWrapper}>
                    <button
                        className={classNames('btnLink', !isHome && 'mr-0')}
                        onClick={toggle}
                    >
                        Close
                    </button>
                    {isHome && (
                        <button
                            id='shopBtnModal'
                            className={classNames('btn-primary', 'btn')}
                            type='submit'
                            onClick={handleSave}
                        >
                            Shop Plans
                        </button>
                    )}
                </div>
            </ModalFooter>
        </Modal>
    );
};

export default PlanOptionModal;
